import { z } from 'zod';

/**
 * Base Stat Filter Schema
 * Mirrors backend/src/schemas/api.ts BaseStatFilterSchema
 */
export const BaseStatFilterSchema = z.object({
	years: z.array(z.number()).optional(),
	maKhoa: z.array(z.string()).optional(),
	maNganh: z.array(z.string()).optional(),
	maTinh: z.array(z.string()).optional(),
	query: z.string().optional(),
	limit: z.number().optional()
}).partial().strip();

// School entity with year-based data for province dialogs
export const SchoolWithYearDataSchema = z.object({
	maTruong: z.string(),
	tenTruong: z.string(),
	top149: z.boolean(),
	oldCodes: z.array(z.object({
		maTruong: z.string(),
		tenTruong: z.string(),
		maNoiBo: z.string().nullable(),
	}).strip()).optional(),
	yearData: z.record(z.string(), z.number()).optional(),
}).strip();

// Choropleth map data item shape
export const MapDataItemSchema = z.object({
	tenTinh: z.string().optional(),
	tinh: z.string().optional(),
	name: z.string().optional(),
	value: z.number().optional(),
}).strip();

export type SchoolWithYearData = z.infer<typeof SchoolWithYearDataSchema>;
export type MapDataItem = z.infer<typeof MapDataItemSchema>;
